export default "__VITE_ASSET__BlUpU9ce__"